export default function HeroSection() {
  return (
    <section className="relative min-h-[620px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 flex">
        <div className="w-full lg:w-[60%] lg:ml-[40%] relative">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20of%20modern%20streetwear%20fashion%20items%20including%20colorful%20sneakers%2C%20a%20forest%20green%20hoodie%2C%20silver%20chain%20accessories%20and%20a%20cap%20scattered%20on%20a%20light%20oak%20parquet%20floor%2C%20soft%20natural%20sunlight%20streaming%20through%20a%20window%2C%20editorial%20photography%20with%20crisp%20shadows%2C%20clean%20minimalist%20composition%2C%20warm%20and%20fresh%20tones%20with%20pops%20of%20color%2C%20styled%20like%20a%20fashion%20magazine%20spread&width=1600&height=1100&seq=hero-main-bg-v3&orientation=landscape"
            alt="CSSBuy Spreadsheet Fashion Finds"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/60 to-transparent"></div>
        </div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-xl">
          <p className="text-foreground-500 text-xs md:text-sm tracking-[0.2em] uppercase mb-4 font-medium">Your Spreadsheet Hub</p>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground-950 font-bold leading-tight mb-6">
            CSSBuy Spreadsheet
            <br />
            <span className="text-primary-500">Finds &amp; Deals</span>
          </h1>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-8 max-w-md">
            The most comprehensive database of hidden streetwear gems, sneaker finds, and fashion spreadsheet deals across CSSBuy, KakoBuy, Superbuy, and Oopbuy — updated daily.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              CSSBuy Sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="#categories"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border-2 border-foreground-300 text-foreground-800 text-sm font-semibold rounded-full hover:border-foreground-800 hover:bg-foreground-800 hover:text-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Explore Drops
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}